import React from 'react';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import { CheckIcon } from '@heroicons/react/24/outline';

const ConfirmDeliveryModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  isLoading = false,
  entity 
}) => {
  const handleConfirm = () => {
    onConfirm({});
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Confirm Delivery"
      size="md"
    >
      <div className="py-4">
        <div className="flex items-center mb-4">
          <CheckIcon className="h-12 w-12 text-green-500 mr-4" />
          <div>
            <h3 className="text-lg font-medium text-gray-900">
              Delivery Received?
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              Please confirm that you have received your order items.
            </p>
          </div>
        </div>
        
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
          <h4 className="text-sm font-medium text-blue-900 mb-2">
            What happens next:
          </h4>
          <ul className="text-sm text-blue-800 space-y-1">
            <li>• Your order will be marked as delivered</li>
            <li>• You'll be able to request returns if needed</li>
            <li>• The merchant will be notified of successful delivery</li>
          </ul>
        </div>

        <div className="flex flex-col sm:flex-row-reverse gap-3">
          <Button
            onClick={handleConfirm}
            disabled={isLoading}
            isLoading={isLoading}
            variant="primary"
            className="flex items-center justify-center"
          >
            <CheckIcon className="h-4 w-4 mr-2" />
            Confirm Delivery
          </Button>
          <Button
            onClick={onClose}
            disabled={isLoading}
            variant="secondary"
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDeliveryModal; 